/* 🤖 this file was generated by svg-to-ts */
export const matIconTimer10Select: {
  name: 'timer-10-select';
  data: string;
} = {
  name: 'timer-10-select',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 8v8h-3V8h3m0-3h-3C8.34 5 7 6.34 7 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zM1 8h2v11h3V5H1v3zm17.5 3c-.83 0-1.5.68-1.5 1.5v2c0 .82.67 1.5 1.5 1.5H21v1h-4v2h4.5c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H19v-1h4v-2h-4.5z"/></svg>`
};
